export default __webpack_public_path__ + "static/media/emblem.1b573fea.svg";